import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";

const rootElement = document.getElementById("root");

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap pre-renders each route into static HTML. When that snapshot is
// present we must hydrate (not re-render) so React reuses the server markup -
// re-rendering with createRoot wipes/duplicates the prerendered DOM and is the
// documented cause of empty/duplicated content (e.g. double <h1>) with react-snap.
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
